/* eslint-disable prettier/prettier */
import React from "react";

const Unlock = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClickHandle}
  >
    <path
      d="M18.4175 8.34574L17.2873 8.69127L16.5963 6.43092C15.9225 4.22709 13.6351 3.01089 11.4313 3.68467C9.22747 4.35845 8.01127 6.64579 8.68505 8.84962L9.37611 11.11L8.24593 11.4555L7.55488 9.19515C6.69106 6.36972 8.26035 3.41832 11.0858 2.5545C13.9112 1.69068 16.8626 3.25996 17.7264 6.0854L18.4175 8.34574Z"
      fill="#1A1B1B"
    />
    <path
      d="M17.2272 20.8629H7.77272C6.76818 20.8629 6 20.0947 6 19.0902V11.9993C6 10.9947 6.76818 10.2266 7.77272 10.2266H17.2272C18.2318 10.2266 18.9999 10.9947 18.9999 11.9993V19.0902C18.9999 20.0947 18.2318 20.8629 17.2272 20.8629ZM7.77272 11.4084C7.41817 11.4084 7.18181 11.6447 7.18181 11.9993V19.0902C7.18181 19.4447 7.41817 19.6811 7.77272 19.6811H17.2272C17.5818 19.6811 17.8181 19.4447 17.8181 19.0902V11.9993C17.8181 11.6447 17.5818 11.4084 17.2272 11.4084H7.77272Z"
      fill="#1A1B1B"
    />
    <path
      d="M12.5002 14.9554C13.1529 14.9554 13.682 14.4263 13.682 13.7736C13.682 13.1209 13.1529 12.5918 12.5002 12.5918C11.8475 12.5918 11.3184 13.1209 11.3184 13.7736C11.3184 14.4263 11.8475 14.9554 12.5002 14.9554Z"
      fill="#1A1B1B"
    />
    <path d="M12.7951 13.7734H12.2042L11.6133 17.3189H13.386L12.7951 13.7734Z" fill="#1A1B1B" />
  </svg>
);

export default Unlock;
